// extracted by mini-css-extract-plugin
module.exports = {"root":"HorizontalSeparator_root__3hh34","text":"HorizontalSeparator_text__1jlz9"};